/** Return milliseconds representation of provided seconds */
export const seconds = (seconds: number) => 1000 * seconds;

/** Return milliseconds representation of provided minutes */
export const minutes = (minutes: number) => seconds(60 * minutes);
